import { render, staticRenderFns } from "./App.vue?vue&type=template&id=55becf81&shadow"
import script from "./App.vue?vue&type=script&lang=ts&shadow"
export * from "./App.vue?vue&type=script&lang=ts&shadow"
function injectStyles (context) {
  
  var style0 = require("./App.vue?vue&type=style&index=0&id=55becf81&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports